import React from 'react';
import { useTranslation } from 'react-i18next';
import { useAppDispatch, useAppSelector } from '../store/hooks';
import { setLanguage } from '../store/slices/userSlice';

export default function LanguageSwitcher() {
    const { i18n, t } = useTranslation();
    const dispatch = useAppDispatch();
    const { language } = useAppSelector(state => state.user || { language: 'en' });
    
    const switchToLanguage = (newLanguage: 'en' | 'zh') => {
        if (newLanguage !== language) {
            console.log('Switching language to:', newLanguage); // Debug log
            
            // Update Redux store (which calls i18n.changeLanguage internally)
            dispatch(setLanguage(newLanguage));
            
            // Explicitly ensure HTML lang attribute is set
            document.documentElement.setAttribute('lang', newLanguage);
        }
    };
    
    return (
        <div className="flex gap-2 pl-4 overflow-hidden 2xs-landscape:hidden xs-landscape:hidden">
            <label htmlFor="language-switcher" className="leading-9 mr-2">{`${t('common.language')}:`}</label>
            <button 
                onClick={() => switchToLanguage('en')}
                className={`py-2 px-3 min-w-[2.8rem] xs:min-w-[4.4rem] text-sm font-medium transition-colors duration-200 rounded-xl ${
                    language === 'en' 
                        ? 'text-white border border-[var(--color-light-gray)]' 
                        : 'border border-transparent bg-transparent text-[var(--color-light-gray)] hover:bg-[var(--color-blue-list-item-hover)]'
                }`}
            >
                <span className="hidden xs:inline">English</span>
                <span className="inline xs:hidden">En</span>
            </button>
            <button 
                onClick={() => switchToLanguage('zh')}
                className={`py-2 px-3 min-w-16 text-sm font-medium transition-colors duration-200 rounded-xl ${
                    language === 'zh' 
                        ? 'text-white border border-[var(--color-light-gray)]' 
                        : 'border border-transparent bg-transparent text-[var(--color-light-gray)] hover:bg-[var(--color-blue-list-item-hover)]'
                }`}
            >
                中文
            </button>
        </div>
    );
} 